import { ErrorHandler as AngularErrorHandler, NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { AuthModule } from '@auth0/auth0-angular';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthErrorComponent } from './pages/auth-error/auth-error.component';
import { EmailNotVerifiedComponent } from './pages/auth-error/email-not-verified/email-not-verified.component';
import { LocaleService } from './services/locale.service';
import { LocaleGuard } from './guards/locale.guard';
import { UserApiController } from './api-controllers/user.api-controller';
import { LifecycleListenerInterfaceToken } from '../core/interfaces/lifecycle-listener.interface';
import { SentryLifecycleListener } from './listeners/sentry-lifecycle.listener';
import { HubspotLifecycleListener } from './listeners/hubspot-lifecycle.listener';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { ErrorHandler } from './handlers/error.handler';

@NgModule({
  declarations: [
    AuthErrorComponent,
    EmailNotVerifiedComponent,
    AuthCallbackComponent,
  ],
  providers: [
    // API Controllers
    UserApiController,

    // Guards
    LocaleGuard,

    // Services
    LocaleService,

    ErrorHandler,
    {
      provide: AngularErrorHandler,
      useClass: ErrorHandler,
    },

    { provide: LifecycleListenerInterfaceToken, useClass: SentryLifecycleListener, multi: true },
    { provide: LifecycleListenerInterfaceToken, useClass: HubspotLifecycleListener, multi: true },
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    AuthModule,
  ],
  exports: [
    AuthErrorComponent,
    EmailNotVerifiedComponent,
    AuthCallbackComponent,
  ],
})
export class AdvancedAuthModule {
}